// 평가 도메인 enum → 한국어 라벨 헬퍼.
// 컴포넌트 파일과 분리해 fast-refresh 경고를 피하고 재사용성을 높인다.

import type { AssessmentClassification, AssessmentScale } from '~/api/types'

const SCALE_LABEL: Record<AssessmentScale, string> = {
    일반: '일반',
    소규모: '소규모',
}

/** 평가 규모 한국어 라벨. */
export function scaleLabel(scale: AssessmentScale): string {
    return SCALE_LABEL[scale]
}

/** 분류 선택지(선행요건/HACCP관리). 라벨이 곧 백엔드 값이다. */
export const CLASSIFICATION_OPTIONS: AssessmentClassification[] = [
    '선행요건',
    'HACCP관리',
]

/** 평가 분류 설명(라디오 보조 텍스트용). */
export const CLASSIFICATION_DESCRIPTION: Record<
    AssessmentClassification,
    string
> = {
    선행요건: '위생관리·시설설비 등 HACCP 적용을 위한 기반 요건',
    HACCP관리: '위해요소 분석·CCP 등 HACCP 관리 체계 요건',
}

/** 단계 선택지(인증/정기). 라벨이 곧 백엔드 값(assessmentType)이다. */
export const ASSESSMENT_TYPE_OPTIONS = ['인증', '정기'] as const

/** 평가 단계 설명(라디오 보조 텍스트용). */
export const ASSESSMENT_TYPE_DESCRIPTION: Record<string, string> = {
    인증: '인증 평가',
    정기: '정기 조사·평가',
}
